/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

var _ = require('lodash');

module.exports = function(helpers, utils) {
    var returnResult = utils.returnResult;

    return {
        array: function(options) {
            return options.args.slice(0, options.args.length);
        },

        isArray: function(options, value) {
            return returnResult(options, this, _.isArray(value));
        },

        some: function(options, array) {
            if (array && array.length === 0) {
                return returnResult(options, this, false);
            }
            return returnResult(options, this, _.some(array));
        },

        neither: function(options, array) {
            if (array && array.length === 0) {
                return returnResult(options, this, true);
            }
            return returnResult(options, this, !_.some(array));
        },

        in: function(options, value) {
            var args = _.drop(arguments, 2);

            return returnResult(
                options,
                this,
                _.includes(_.flatten(args), value),
            );
        },

        join: function(options, array, separator) {
            return array.join(separator);
        },

        map: function(options, array, predicate) {
            return _.map(array, predicate);
        },

        reverse: function(options, array) {
            return _.reverse(array);
        },

        sort: function(options, array, propName) {
            return _.sortBy(array, propName);
        },

        lengthEqual: function(options, array, length) {
            return returnResult(options, this, array.length === length);
        },

        empty: function(options, array) {
            return returnResult(options, this, array.length === 0);
        },

        after: function(options, array, count) {
            return returnResult(options, this, array.slice(count));
        },

        before: function(options, array, count) {
            return returnResult(options, this, array.slice(0, -count));
        },

        first: function(options, array) {
            return returnResult(options, this, _.first(array));
        },

        last: function(options, array) {
            return returnResult(options, this, _.last(array));
        },

        contains: function(options, str, val) {
            return returnResult(options, this, str.indexOf(val) !== -1);
        },
    };
};
